import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import FormRow from "@/components/Common/FormRow.vue"

export default /*@__PURE__*/_defineComponent({
  __name: 'FormTextField',
  props: {
    title: {},
    modelValue: {},
    error: {},
    windowInnerWidth: {},
    required: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    rowContentClass: { default: '' }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(FormRow, {
    title: props.title,
    windowInnerWidth: props.windowInnerWidth,
    required: props.required,
    rowContentClass: props.rowContentClass
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_text_field, {
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
        "error-messages": props.error,
        maxlength: "255",
        readonly: __props.readonly,
        clearable: !__props.readonly
      }, null, 8, ["modelValue", "error-messages", "readonly", "clearable"])
    ]),
    _: 1
  }, 8, ["title", "windowInnerWidth", "required", "rowContentClass"]))
}
}

})